import React, { useState, useEffect, useRef } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { ShoppingBagIcon } from "@heroicons/react/24/outline";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";

const menuItems = {
  en: [
    { id: 1, label: "Turkish Stores", href: "/category-turkey" },
    { id: 2, label: "European Stores", href: "/category-europe" },
  ],
  ar: [
    { id: 1, label: "المتاجر التركية", href: "/category-turkey" },
    { id: 2, label: "المتاجر الأوروبية", href: "/category-europe" },
  ],
};

const CustomDropDownNavBar = ({ language = "en" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const navigateWithLang = useLanguageNavigate();

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Handle clicks outside the dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Ensure we are fetching the right language items
  const items = menuItems[language] || menuItems.en;
  const direction = useLanguageDirection();

  return (
    <div
      style={{
        position: "relative",
        marginLeft: 0,
        marginBottom: "",
      }}
      dir={direction}
    >
      <button
        ref={buttonRef}
        className="flex items-center gap-1 text-left lg:mt-1 lg:items-stretch lg:mx-4 group"
        onClick={toggleDropdown}
        // onMouseEnter={() => setIsOpen(true)}
        // onMouseLeave={() => setIsOpen(false)}
        style={{
          display: "flex",
          background: "transparent",
          border: "none",
          color: "white",
        }}
        dir={direction === "rtl" ? "ltr" : "rtl"}
      >
        <ChevronDownIcon className="w-4 h-4 text-white lg:mt-1 group-hover:text-custom-yellow" />
        <div className="flex flex-col">
          <span className="font-medium text-white duration-300 group-hover:text-custom-yellow md:text-[15px]">
            {language === "ar" ? "متاجر التسوق" : "Shopping Stores"}
          </span>
          <div
            style={{ width: "50px" }}
            className={`h-[4px] mx-auto hidden lg:block mt-1 duration-300 group-hover:bg-custom-yellow`}
          ></div>
        </div>
        <ShoppingBagIcon className="w-5 h-5 lg:mt-1 lg:h-4 lg:w-4 group-hover:text-custom-yellow" />
      </button>
      {isOpen && (
        <ul
          ref={dropdownRef}
          dir={direction}
          className="z-50 rounded-custom lg:absolute mt-3 text-black  lg:bg-white bg-black  rounded-[3px] shadow-lg start-5 w-56 md:w-72 "
        >
          <div
            className={`hidden lg:block lg:absolute w-0 h-0 border-b-8 border-l-8 border-r-8 ${
              direction === "rtl" ? "right-[4.2rem]" : "left-[4.2rem]"
            }  -top-2 border-l-transparent border-r-transparent border-b-white`}
          ></div>

          {items.map((item) => (
            <li
              className="relative flex items-center text-white duration-700 cursor-pointer lg:divide-solid lg:text-black group hover:lg:bg-custom-yellow hover:rounded-[3px]"
              key={item.id}
              style={{
                padding: "10px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => {
                setIsOpen(false);
                navigateWithLang(item.href);
              }}
            >
              <span className="text-white duration-300 lg:text-black group-hover:lg:text-black ">
                {item.label}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropDownNavBar;
